<template>
  <div class="page-container">
    <div class="template-main" ref="main" >
      <div class="header">
        <img :src="templateContent.headerImg" class="template-img" />

        <div class="operation">
          <div class="header-btns">
            <div class="header-btn-item" @click="goInvoice" ></div>
            <div class="header-btn-item" @click="navOrder" ></div>
            <div class="header-btn-item" @click="showRule"></div>
            <div class="header-btn-item" @click="moreQuestion"></div>
          </div>
          <div class="apply-btn" ref="obu" @click="handleApplyBtn"></div>
        </div>
      </div>
      <template v-if="templateContent.preTemplateImgs">
        <div  v-for="(item, index) in templateContent.preTemplateImgs" :key="index" class="template-img-item" >
          <img :src="item.src" class="template-img" />
        </div>
      </template>
      <div v-for="(item, index) in templateContent.productImgs" :key="index" class="template-img-item product-item">
        <img :src="item.src" class="template-img" />
        <div class="product-btn" ref="obu" @click="goNext('产品' + (index + 1) +'-办理')"></div>
      </div>
      <div v-for="(item, index) in templateContent.templateImgs" :key="index" class="template-img-item">
        <img :src="item.src" class="template-img" />
      </div>
      <!-- <div class="question-more" @click="moreQuestion"></div> -->
      <div class="template-btn-box">
        <div class="btn-container" @click="goNext('领取申办')">
          <img :src="templateContent.btnImg" class="template-btn" />
        </div>
      </div>
    </div>
    <!-- <div ref="main" class="landing" >
      <div class="main">
        <div class="header">
          <div class="tab-list">
            <div @click="goInvoice" class="tab-item">
              <div class="tab-icon-container">
                <img src="https://wecos.etczs.net/h5/bank-apply/invoce-icon.png" class="tab-icon">
              </div>
              <div class="tab-title">发票入口</div>
            </div>
            <div @click="navOrder" class="tab-item">
              <div class="tab-icon-container">
                <img src="https://wecos.etczs.net/h5/bank-apply/order-icon.png" class="tab-icon">
              </div>
              <div class="tab-title">我的订单</div>
            </div>
            <div @click="showRule" class="tab-item">
              <div class="tab-icon-container">
                <img src="https://wecos.etczs.net/h5/bank-apply/rule-icon.png" class="tab-icon">
              </div>
              <div class="tab-title">活动规则</div>
            </div>
            <div @click="moreQuestion" class="tab-item">
              <div class="tab-icon-container">
                <img src="https://wecos.etczs.net/h5/bank-apply/service-icon.png" class="tab-icon">
              </div>
              <div class="tab-title">ETC客服</div>
            </div>
          </div>
        </div>
      </div>
      <img src="https://wecos.etczs.net/H5/bank-apply/new-bank-normal-img-02-2.png" class="normal-img-2">
      <div class="obu" ref="obu">
        <div class="obu-title">2025 AI语音时代来临</div>
        <div class="obu-list">
          <div class="obu-item-box obu-bt-box" >
            <div class="obu-item" @click="changeObuDesc(1)">
              <img src="https://wecos.etczs.net/H5/bank-apply/obu-item-img-01-new.png" class="obu-item-img">
              <div class="obu-item-info">
                  <div class="obu-item-info-box">
                    <div class="obu-item-title-new">语音隐藏款</div>
                    <div class="btn-handle" @click="goNext('东风日产-语音隐藏款申办')">
                      <div class="btn-handle-text">办理</div>
                      <img src="https://wecos.etczs.net/H5/bank-apply/h5-btn-rignt-icon.png" class="btn-handle-img">
                    </div>
                  </div>
                
                <div class="obu-item-tags">
                  <div class="obu-tag-item">免贴玻璃</div>
                  <div class="obu-tag-item">隐藏安装</div>
                  <div class="obu-tag-item">无感过闸</div>
                </div>
              </div>
            </div>
            <div class="obu-rollup-bg-box">
              <div class="obu-prod-price">¥<span class="obu-prod-price-origin">{{ channel === 'baidu' ? 300: 360 }}</span></div>
              <div class="obu-prod-content">
                <div class="obu-prod-content-title">高速路费券</div>
                <div class="obu-prod-content-pre">办语音隐藏款设备可获得</div>
              </div>
            </div>
          </div>
          <div class="obu-item-box">
            <div class="obu-item" @click="changeObuDesc(2)">
              <img src="https://wecos.etczs.net/H5/bank-apply/obu-item-img-02.png" class="obu-item-img">
              <div class="obu-item-info">
                <div class="obu-item-info-box">
                    <div class="obu-item-title-new">语音穿膜款</div>
                    <div class="btn-handle" @click="goNext('东风日产-语音穿膜款申办')">
                      <div class="btn-handle-text">办理</div>
                      <img src="https://wecos.etczs.net/H5/bank-apply/h5-btn-rignt-icon.png" class="btn-handle-img">
                    </div>
                </div>

                <div class="obu-item-tags">
                  <div class="obu-tag-item">贴玻璃款</div>
                  <div class="obu-tag-item">行业最小</div>
                  <div class="obu-tag-item">穿透车膜</div>
                </div>
              </div>
            </div>
            <div class="obu-rollup-bg-box">
              <div class="obu-prod-price">¥<span class="obu-prod-price-origin">{{ channel === 'baidu' ? 180: 240 }}</span></div>
              <div class="obu-prod-content">
                <div class="obu-prod-content-title">高速路费券</div>
                <div class="obu-prod-content-pre">办语音穿膜款设备可获得</div>
              </div>
            </div>
          </div>
        </div>
        <div class="obu-title-last">* 路费券按月领取核销，每月一张，领后通行高速ETC自动核销</div>
      </div>
      <img src="https://wecos.etczs.net/H5/bank-apply/bank-new-normal-bg-01.png" class="normal-img-1 ">
      <div class="last-image-add"></div>
      <view class="fixed-btn">
        <img src="https://wecos.etczs.net/h5/bank-apply/submit-btn-0722.png" @click="goNext('东风日产-领取申办')" class="submit-btn" />
      </view>
    </div> -->
    <Popup position="bottom" class="rule-popup" :show="rulePopupVisible" @click-overlay="rulePopupVisible = false">
      <div class="rule-container" v-if="templateContent.rule">
        <img @click="rulePopupVisible = false" src="https://wecos.etczs.net/H5/newApply/coupon-apply-close-popup.png" class="close-btn" />
        <div class="rule-title">活动规则</div>
        <div class="rule-scroll">
          <span v-html="templateContent.rule"></span>
        </div>
      </div>
      <div class="rule-container" v-else>
        <img @click="rulePopupVisible = false" src="https://wecos.etczs.net/H5/newApply/coupon-apply-close-popup.png" class="close-btn" />
        <div class="rule-title">活动规则</div>
        <div class="rule-scroll">
          <div class="rule-sub-title">1、活动时间：</div>
          <div class="rule-content">2024年1月16日00:00-2024年12月31日23:59</div>
          <div class="rule-sub-title">2、活动内容：</div>
          <div class="rule-content">通过该活动页面前往办理【三代隐藏款ETC】或【二代穿膜款ETC】套餐可享300元或180元通行路费券，并附赠3年质保和1年高速救援补贴：</div>
          <div class="rule-content">1）300元路费补贴券在设备激活后可在【微信ETC助手小程序-我的-优惠券-优惠月月领】领取，分20个月发放，每月发放三类券种，包含：①满15.01-15元路费抵扣券，领取后10天内有效；②满11.01-11元洗车抵扣券，领取后3天内有效；③满15.01-15元加油抵扣券，领取后3天内有效。以上三类券种每月可选择1张进行领取，先领后用。</div>
          <div class="rule-content">2）180元路费补贴券在设备激活后可在【微信ETC助手小程序-我的-优惠券-优惠月月领】领取，分18个月发放，每月发放三类券种，包含：①满15-10元路费抵扣券，领取后10天内有效；②满11.01-11元洗车抵扣券，领取后3天内有效；③满15.01-15元加油抵扣券，领取后3天内有效。以上三类券种每月可选择1张进行领取，先领后用。</div>
          <div class="rule-sub-title">*高速救援补贴：</div>
          <div class="rule-content">办理套餐后附赠价值500元高速救援补贴，激活后可领，高速出现非事故拖车、接电、送水时，凭发票可报销500元。限微保车主新用户领取，仅9座及以下的非营运私家车可领取。</div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast, } from 'vant'
import { apiGetProductListNologin } from '@/api/apply'
import { apiGetTemplate } from '@/api/enterprise'

import { 
  // Image as VanImage, 
  Popup 
} from 'vant'
import { navToService, setIndexPage } from '@/utils/common'
import ETC from '@/config/etc'

import qs from 'qs'
import { biLog } from '@/api/bi' 
export default {
  data() {
    return {
      hasGetCoupon: false,
      rulePopupVisible: false,
      // pl: 2568,
      describeVisible: true,
      isApply: true,
      abType: 'B',
      bizExt: '',
      loginMerge: 0,
      currentObuIndex: 1,
      templateContent: {},
    }
  },
  computed: mapState(['entryInfo', 'channel']),
  components: {
    // VanImage,
    Popup,
  },
  methods: {
    ...mapActions(['checkLogin']),
    ...mapMutations(['setToken', 'setIsLogin', 'setChannel', 'setApplyInfo', 'setQaList']),
    showRule() {
      this.rulePopupVisible = true
      this.biStat({
        region: '',
        obj_name: '东风日产-活动规则',
      })
    },
    // changeObuDesc(index) {
    //   this.currentObuIndex = index
    //   switch (index) {
    //     case 1:
    //       this.biStat({
    //         region: '',
    //         obj_name: '东风日产-第一个',
    //       })
    //       break;
    //     case 2:
    //       this.biStat({
    //         region: '',
    //         obj_name: '东风日产-第二个',
    //       })
    //       break;
    //   }
    // },
    // 
    goService() {
      navToService()
      this.biStat({
        region: '',
        obj_name: '东风日产-ETC客服',
      })
    },
    biStat(data) {
      biLog({
        ...data,
        extra_args: this.$route.query
      })
    },
    goNext(obj_name) {
      this.handleApplyBtn()
      this.biStat({
        region: '',
        obj_name: (this.channel || '') + obj_name,
      })

    },
    moreQuestion() {
      this.$router.push({
        path: '/qa/index',
      })
      //location.href = 'https://modalh5.etczs.net/service-qa'
    },
    scrollHeight() {
      //this.describeVisible = true
      this.$nextTick(() =>{
        let main = this.$refs.main
        let targetPosition = this.$refs.target.offsetTop;
        main.scrollTo({
          top: targetPosition,
          behavior: 'smooth' // 平滑滚动
        });
      })
    },

    async handleApplyBtn() {
      if (this.abType === 'C') {
        this.$router.push({
          path: '/apply/chooseproduct',
          
        })
      } else if (!this.loginMerge && !await this.checkLogin()) {
        this.$router.push({
          path: '/login',
          query: {
            redirectLink: '/third/bank',
            redirectQuery: JSON.stringify({
              isApply: this.isApply,
              loginMerge: this.loginMerge,
              pl: this.pl,
              abType: this.abType,
              bizExt: this.bizExt,
              applyType: 'bank',
              channel: this.channel,

            })
          }
        })
        return
      } else {
        await this.getProd()
        this.$router.push({
          path: '/apply/AddAddress',
        })
      }
    },
    async getProd() {
      try{
        const res = await apiGetProductListNologin({
          pl: this.pl
        })
        const product = res?.products
        if (product?.length > 0) {
          this.setApplyInfo({
            package: product,
          })
        } else {
          Toast({
            message: '产品包获取失败，请刷新或重新进入尝试'
          })
          throw new Error('产品包获取失败，请刷新或重新进入尝试')
        }
      }catch(err){
        setTimeout(() => {
          location.reload()
        },1000)
      }
    },
    async goInvoice() {
      if (!await this.checkLogin()) {
        this.$router.push({
          path: '/login',
          query: {
            redirectLink: '/invoice/center',
          }
        })
        return
      } else {
        this.$router.push({
          path: '/invoice/center',
        })
      }
      this.biStat({
        region: '',
        obj_name: '东风日产-发票入口',
      })
    },
    async navOrder() {
      this.biStat({
        region: '',
        obj_name: '东风日产-我的订单',
      })
      if (!await this.checkLogin()) {
        this.$router.push({
          path: '/login',
          query: {
            redirectLink: '/third/bank',
            redirectQuery: JSON.stringify({
              isApply: this.isApply,
              pl: this.pl,
              abType: this.abType,
              channel: this.channel,
              bizExt: this.bizExt,
              applyType: 'bank',
              loginMerge: this.loginMerge
            })
          }
        })
      } else {
        this.$router.push({
          path: '/apply/orderlist',
          query: {
            pl: this.pl,
            applyType: 'bank',
            isApply: this.isApply,
            abType: this.abType,
            bizExt: this.bizExt,
            loginMerge: this.loginMerge
          }
        })
      }
    },
    async getTempImg() {
      const defaultPageSn = '2511111716000001096'
      let res
      try {
        const pageSn = this.$route?.query?.pageSn || this.entryInfo?.pageSn || localStorage.getItem(ETC.SESSION_STORAGE_KEY.BANK_PAGESN) || defaultPageSn
        res = await apiGetTemplate({
          pageSn,
          pageCategory: 7
        })
        if (!res?.content && pageSn != defaultPageSn) {
          res = await apiGetTemplate({
            pageSn: defaultPageSn,
            pageCategory: 7
          })
        }
        this.templateContent = res?.content|| {}
      } catch (error) {
        console.error(error)
      }
    },
  },

  async created() {
    setIndexPage()
    console.log('this.$route.query',this.$route.query)
    this.pl = this.$route.query.pl || this.pl || this.entryInfo.pl
    this.abType = this.$route.query.abType || 'B'
    this.bizExt = this.$route.query.bizExt || ''
    this.loginMerge = +this.$route.query.loginMerge || 0
    localStorage.setItem('applyInfo', JSON.stringify({
      applyType: 'bank',
      isApply: this.isApply,
      loginMerge: this.loginMerge,
      pl: this.pl,
      abType: this.abType,
      channel: this.channel,
      bizExt: this.bizExt,
    }))
    this.biStat({
      region: '首页',
      obj_name: '首页',
      action_id: 201,
    })
    this.getTempImg()

   
  },
  mounted() {
    setTimeout(() => {
      this.hasGetCoupon = true
    }, 100);
    const intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          this.biStat({
            region: '',
            obj_name: '东风日产-产品区',
            action_id: 211
          })
        }
      })
    })
    intersectionObserver.observe(this.$refs.obu)

  }
}
</script>

<style lang="less">
.page-container {
  height: 100%;
  position: relative;
  // overflow: hidden;
  /* & img {
    pointer-events: none;
  } */
}
.template-main {
  padding-bottom: 200px;
  background-color: #000;
  position: relative;
  .header {
  }
  .template-img {
    width: 100%;
  }
  .product-item {
    position: relative;
    .product-btn {
      position: absolute;
      width: 200px;
      height: 100px;
      right: 40px;
      top: 30px;
    }
  }
  .template-btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    // background-color: #000;
    // border-top: 1px solid #444;
    .btn-container {
      margin: 0 auto;
      width: 750px;
      position: relative;
    }
    .template-btn {
      display: block;
      width: 100%;
    }
 
    .btn-light {
      position: absolute;
      top: -18px;
      left: -100%;
      width: 170px;
      height: 122px;
      animation: btnLight 1.5s linear infinite;
    }
    @keyframes btnLight {
      from {
        left: -100%;
      }
      
      to {
        left: 100%;
      }
    }
  }
  .operation {
    .header-btns {
      position: absolute;
      top: 700px;
      padding: 0 44px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-btn-item {
        width: 120px;
        height: 180px;
      }
    }
    .apply-btn {
      position: absolute;
      top: 1260px;
      right: 60px;
      width: 136px;
      height: 70px;
    }
  }
}
.question-more {
  position: absolute;
  width: 491px;
  height: 126px;
  left: 130px;
  bottom: 80px;
  z-index: 1;

}
.landing {
  width: 750px;
  height: 100vh;
  overflow: auto;
  position: relative;
  .header {
    background-image: url(https://wecos.etczs.net/h5/bank-apply/new-bank-kv.png);
    height: 1142px;
    width: 750px;
    background-size: contain;
    background-repeat: no-repeat;
    .tab-list {
      padding: 886px 40px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tab-item {
      text-align: center;
      .tab-icon-container {
        backdrop-filter: blur(5px);
        background: linear-gradient(to left bottom, #9DABB7, #647280);
        padding-top: 30px;
        box-sizing: border-box;
        margin: 0 auto;
        width: 128px;
        border-radius: 8px;
        height: 128px;
      }
      .tab-icon {
        margin: 0 auto;
        width: 68px;
        height: 68px;
      }
      .tab-title {
        padding-top: 20px;
        font-size: 28px;
        line-height: 40px;
        color: #fff;
        font-weight: lighter;
        
      }
    }
  }
  .coupon {
    background-color: #101010;
    .coupon-title {
      padding: 68px 0 45px;
      text-align: center;
      color: #fff;
      line-height: 70px;
      font-size: 48px;
    }
    .coupon-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px 50px;
      .coupon-list-item {
        width: 321px;
        height: 140px;
        background-image: url(https://wecos.etczs.net/H5/bank-apply/obu-list-item-bg.png);
        background-size: contain;
        background-repeat: no-repeat;
        padding: 14px 0 0 28px;
        box-sizing: border-box;
      }
      .coupon-list-item-title {
        font-size: 36px;
        line-height: 52px;
        color: #fff;
        font-weight: 500;
      }
      .coupon-list-item-desc {
        padding-top: 8px;
        font-size: 28px;
        line-height: 40px;
        color: #fff;
      }
    }
    .coupon-apply-btn {
      display: flex;
      width: 300px;
      margin: 0 auto;
      align-items: center;
      justify-content: center;
      color: #fff;
      .arrow-r-white {
        padding-left: 6px;
        display: block;
        width: 36px;
        height: 36px;
      }
    }
    .coupon-tips {
      padding: 32px 40px 24px;
      font-size: 20px;
      line-height: 28px;
      color: #fff;
    }
  }
  .obu {
    width: 100%;
    padding: 80px 40px 49px;
    box-sizing: border-box;
    background-color: #2C3039;
    .obu-title {
      font-size: 48px;
      line-height: 70px;
      color: #fff;
      text-align: center;
    }
    .obu-list {
      padding-top: 52px;
      .obu-bt-box {
        margin-bottom: 40px
      }
      .obu-item-box {
        background-image: url('https://wecos.etczs.net/H5/bank-apply/obu-box-bg.png');
        width: 670px;
        height: 420px;
        background-size: contain;
        background-repeat: no-repeat;
        .obu-rollup-bg-box{
          position: relative;
          width: 605px;
          height: 132px;
          background-image: url('https://wecos.etczs.net/H5/bank-apply/obu-rollup-bg.png');
          background-size: contain;
          background-repeat: no-repeat;
          margin-left: 37px;
          .obu-prod-price{
            font-size: 36px;
            color: #fff;
            position: absolute;
            top: 48px;
            left: 35px;
            font-size: 32px;
            font-weight: 600;
            .obu-prod-price-origin {
              font-size: 50px;
              color: #fff;
              font-weight: 600;
            }
          }
          .obu-prod-content{
            position: absolute;
            color: #fff;
            top: 26px;
            right: 70px;
            .obu-prod-content-title {
              font-size: 36px;
              line-height: 36px;
              margin-bottom: 14px;
              color: #FFFFFF;
              font-weight: 500;
            }
            .obu-prod-content-pre {
              font-size: 28px;
              color: #FFFFFF;
              font-weight: lighter;
            }
          }
        }
      }
      .obu-item {
        position: relative;
        // margin-bottom: 40px;
        display: flex;
        align-items: center;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      .obu-item-img {
        padding-left: 20px;
        width: 248px;
        box-sizing: border-box;
        height: 248px;
        display: block;
      }
      .obu-item-info {
        padding-left: 18px;
        .obu-item-info-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .btn-handle {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 136px;
            height: 60px;
            line-height: 60px;
            margin-right: 6px;
            // background: #FFFFFF;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 36px;
            text-align: center;
            .btn-handle-text {
              font-size: 28px;
              color: #687684;
              padding-top: 3px;
              box-sizing: border-box;
              padding-left: 8px;

            }
            .btn-handle-img {
              width: 36px;
              height: 36px;
              margin-left: 4px;
              margin-top: 2px;
            }
          }
          
        }
      }
      .obu-item-title-new{
        font-size: 40px;
        color: #fff;
        line-height: 58px;
        font-weight: lighter;
      }
      .obu-item-title {
        font-size: 40px;
        color: #fff;
        line-height: 58px;
      }
      .obu-item-tags {
        padding-top: 42px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
      .obu-tag-item {
        border: 1px solid #fff;
        border-radius: 4px;
        opacity: 0.7;
        padding: 7px 6px;
        box-sizing: border-box;
        text-align: center;
        width: 116px;
        height: 48px;
        box-sizing: border-box;
        font-size: 24px;
        line-height: 36px;
        color: #fff;
        margin-right: 12px;
        font-weight: lighter;
      }
      .obu-selected {
        position: absolute;
        top: 53px;
        right: 25px;
        width: 48px;
        height: 48px;
      }
    }
  }
  .obu-desc {
    display: block;
    width: 750px;
    height: 1118px;
  }
  .normal-img-1 {
    display: block;
    width: 750px;
    height: 1711px;
  }
  .last-image-add {
    height: 180px;
    background: #101010;
  }
  .normal-img-2 {
    display: block;
    width: 750px;
    height: 1688px;
  }
  .rule {
    position: absolute;
    right: 0;
    top: 487px;
    border-radius: 14px 0 0 14px;
    //background-color: #BB340A;
    background-color: #12822A;
    text-align: center;
    //color: #FDC6BA;
    color: #C1FF02;
    font-size: 24px;
    line-height: 30px;
    padding: 10px 0;
    width: 70px;
    z-index: 99;
  }
  .order {
    position: absolute;
    right: 0;
    top: 569px;
    border-radius: 14px 0 0 14px;
    background-color: #FB5436;
    text-align: center;
    color: #FFFFFF;
    font-size: 24px;
    line-height: 30px;
    padding: 10px 0;
    width: 70px;
    z-index: 99;
  }
  .content {
    position: absolute;
    left: 0;
    bottom: 40px;
    width: 750px;
    z-index: 2;
  }
  .title {
    margin: 164px auto 90px;
    transition: margin 0.3s;
    position: relative;
    width: 510px;
    height: 60px;
    .title-img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transition: opacity 0.3s;
      &.hide {
        opacity: 0;
      }
    }
    &.has-get {
      margin-bottom: 40px;
    }
  }
  .coupon-btn {
      position: absolute;
      left: 140px;
      bottom: 60px;
      width: 491px;
      height: 126px;
      transition: all 0.3s;
      &:active {
        transform: scale(0.95);
      }
      &.hide {
        display: none;
      }
      &.ani {
        animation: blink 1.5s;
        animation-delay: 0.3s;
      }
    }
    @keyframes blink{
      0%{
        transform: scale(1);
      }
      25%{
        transform: scale(0.9);
      }
      50%{
        transform: scale(1);
      }
      75%{
        transform: scale(0.9);
      }
      100%{
        transform: scale(1);
      }
    }
 
  .banner {
    position: absolute;
    top: 761px;
    left: 0;
    width: 750px;
    height: 258px;
  }

  .fixed-btn {
    position: fixed;
    bottom: 0;
    width: 750px;
    height: 228px;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: linear-gradient( 180deg, rgba(157,170,182,0) 0%, #525558 58%, #000000 100%);
    background-image: url('https://wecos.etczs.net/H5/bank-apply/new-btn-bg-01.png');
    background-position: center;
    background-size: cover;
    .submit-btn {
      width: 642px;
      height: 100px;
      display: block;
      
    }
    .submit-btn-text {
      width: 642px;
      height: 100px;
      text-align: center;
      background: #E5CBA5;
      color: #523E33;
      font-weight: 600;
      border-radius: 50px;
      font-size: 36px;
      line-height: 100px;
      animation: breathe 3s infinite;
    }
    @keyframes breathe {
     0% {
       transform: scale(1);
     }
     50% {
       transform: scale(1.03);
     }
     100% {
       transform: scale(1);
     }
   }

  }
  .obu-title-last {
    font-size: 24px;
    color: #afb4bd;
    line-height: 35px;
    text-align: center;
    margin-top: 52px;
    font-weight: lighter;
  }
}
.rule-popup {
  border-radius: 32px 32px 0 0;
}
.rule-container {
  padding: 0 20px 90px 40px;
  position: relative;
  .rule-scroll {
    max-height: 1000px;
    overflow: auto;
    padding-right: 20px;
  }
  .close-btn {
    position: absolute;
    top: 43px;
    left: 40px;
    width: 48px;
    height: 48px;
  }
  .rule-title {
    font-size: 36px;
    line-height: 54px;
    color: #333;
    font-weight: 500;
    padding: 40px 0 36px;
    text-align: center;
  } 
  .rule-sub-title {
    font-size: 28px;
    color: #333;
    font-weight: 500;
    line-height: 50px;
  }
  .rule-content {
    font-size: 26px;
    line-height: 50px;
    color: #333;
  }
}
</style>